import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import Tooltip from "./Tooltip";
const ErrorFormTooltip = ({
  shown,
  onShown,
  error,
  help,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, shown && help && !error && /*#__PURE__*/React.createElement(Tooltip, _extends({
    isHelp: true,
    shown: shown,
    onShown: () => onShown(prev => !prev)
  }, props), help), shown && error && /*#__PURE__*/React.createElement(Tooltip, _extends({
    shown: shown,
    onShown: value => onShown(value)
  }, props), error));
};
export default ErrorFormTooltip;